import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *transloco="let t">
      @if (isLoading()) {
        <div
          class="fixed top-0 left-0 w-full h-1 z-9999 overflow-hidden bg-primary/20 pointer-events-none"
          role="progressbar"
          [attr.aria-valuetext]="t('nav.loading')"
        >
          <div class="h-full w-1/2 origin-left animate-progress bg-primary"></div>
        </div>
      }
    </ng-container>
  `,
})
export class GlobalLoaderComponent {
  private readonly _loadingService = inject(LoadingService);
  public readonly isLoading = this._loadingService.isLoading;
}
